import { createSelector } from '@ngrx/store';
import { selectAppState } from '../../reducers/reducer.selector';


export const selectEditorState = createSelector(
  selectAppState,
  (state) => state.editor
)

export const selectSelectedLayer = createSelector(
  selectEditorState,
  (state) => state.selectedLayer
)

export const selectLayers = createSelector(
  selectEditorState,
  (state) => state.layers
)

export const selectLayerOrder = createSelector(
  selectEditorState,
  (state) => state.layerOrder
)

export const selectSelectedEffect = createSelector(
  selectEditorState,
  (state) => state.selectedEffect
)

export const selectRenderName = createSelector(
  selectEditorState,
  (state) => state.renderName
)

export const selectRenderId = createSelector(
  selectEditorState,
  (state) => state.renderId
)
